import React from "react";

export const OrderStatistics = (props) => (
  <div className="order_statistics">
    <div>{props.children}</div>
  </div>
);
